.reload-icon {
  cursor: pointer;
  vertical-align: middle;
  margin-left: 10px;
}

.log-toolbar {
  flex-wrap: wrap;
  row-gap: 8px;
}

.log-toolbar .download-item {
  margin-left: auto;
}

.log-container {
  --log-stamp: #3c89e8;
  --log-debug: #3c89e8;
  --log-info: #008771;
  --log-notice: #008771;
  --log-warning: #f37b24;
  --log-error: #e04141;
  --log-unknown: #595959;
  --log-divider: rgba(128, 128, 128, 0.18);

  margin-top: 12px;
  padding: 10px 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 60vh;
  overflow-y: auto;
  border: 1px solid var(--ant-color-border);
  border-radius: 6px;
  background: var(--ant-color-fill-tertiary);
  color: var(--ant-color-text);
}

.log-stamp {
  color: var(--log-stamp);
}

.log-level {
  margin-left: 4px;
}

.level-debug {
  color: var(--log-debug);
}

.level-info {
  color: var(--log-info);
}

.level-notice {
  color: var(--log-notice);
}

.level-warning {
  color: var(--log-warning);
}

.level-error {
  color: var(--log-error);
}

.level-unknown {
  color: var(--log-unknown);
}

.log-container-mobile {
  padding: 8px;
  white-space: normal;
  max-height: 70vh;
}

.log-empty {
  text-align: center;
  opacity: 0.5;
  padding: 20px 0;
}

.log-line + .log-line {
  margin-top: 2px;
}

.log-card {
  border-bottom: 1px solid var(--log-divider);
  padding: 8px 0;
}

.log-card:last-child {
  border-bottom: 0;
}

.log-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}

.log-time {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.02em;
}

.log-date {
  font-size: 10px;
  font-weight: 500;
  opacity: 0.55;
}

.log-level-badge {
  display: inline-block;
  font-size: 10px;
  line-height: 14px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid currentColor;
  letter-spacing: 0.04em;
  font-weight: 600;
  white-space: nowrap;
  background: color-mix(in srgb, currentColor 14%, transparent);
}

.log-body {
  font-size: 12px;
  word-break: break-word;
}

.log-body-text {
  margin-left: 4px;
}

body.dark .log-container {
  --log-stamp: #6aa6ee;
  --log-debug: #6aa6ee;
  --log-info: #4ed3a6;
  --log-notice: #4ed3a6;
  --log-warning: #ffb872;
  --log-error: #ff7575;
  --log-unknown: #b5b5b5;
  --log-divider: rgba(255, 255, 255, 0.1);
}

html[data-theme="ultra-dark"] .log-container {
  --log-stamp: #7fb6f1;
  --log-debug: #7fb6f1;
  --log-info: #5fd9b0;
  --log-notice: #5fd9b0;
  --log-warning: #ffcc88;
  --log-error: #ff8a8a;
  --log-unknown: #c4c4c4;
  --log-divider: rgba(255, 255, 255, 0.12);
}

.logmodal-mobile .ant-modal-content {
  border-radius: 0;
  height: 100vh;
}

.logmodal-mobile .ant-modal-body {
  padding: 12px;
}
